import { render, staticRenderFns } from "./RegisterPayment.vue?vue&type=template&id=4422ddba"
import script from "./RegisterPayment.vue?vue&type=script&lang=js"
export * from "./RegisterPayment.vue?vue&type=script&lang=js"
import style0 from "./RegisterPayment.vue?vue&type=style&index=0&id=4422ddba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports